import { LineChartComponent } from "./lineChart";

export const AppLineChart = LineChartComponent;
